export const apiUrl = (prefix: string)=>`http://github.vyatkin.com/dashboard/api/${prefix}`;
